export interface YourDependantDetails {
    title: string;
    otherTitle: string;
    forename: string;
    surname: string;
    middleName: string;
    thirdName: string;
    dateOfBirth: string;
    gender: string;
    maritalStatus: string;
    relationShip: string;
}
